import {arraysAreShallowlyEqual} from "./arrays.js";

/**
 * Utilityfunktion för att transformera en input ur vårt Redux state till en array eller ett objekt utan att varje gång skapa ett nytt objekt som output.
 * Givet exakt samma input kommer inte ens mapfunktionen anropas på nytt, så input till output måste vara deterministiskt.
 * 
 * @param {Function} transformFunction - Deterministisk funktion som transformerar input (typiskt något i stil med "state.authentication.signedInAs") till ett outputobjekt eller en array.
 * @returns {Object?|Array?} - Givet samma input (med shallow comparison) som förra anropet samma objekt igen och annars det nya resultatet.
 */
export function createReselector(transformFunction) {
    let lastResult = undefined;
    let lastInputs = undefined;

    return (...input) => {
        if (arraysAreShallowlyEqual(lastInputs, input)) {
            return lastResult;
        }

        lastInputs = input;
        lastResult = transformFunction(...input);

        return lastResult;
    };
}


/**
 * Skapar en konstant funktion lämplig att använda till onEdit funktioner som bind till gridens
 * column onEdit callback.
 * 
 * Ex: 
 * const myOnChangePallet = createBoundFunction();
 * 
 * const mergeProps = (...) => ({
 *   ...,
 *   onChangePallet: myOnChangePallet((source, change) => dispatchProps.onChangePallet(ownProps.subSys, stateProps.changes, source, change))
 * });
 *
 * Ovanstående kod genererar en konstant funktion till onChangePallet som alltid blir den samma oavsett vilka övriga properties som ändras. 
 * 
 * @returns {func}
 */
export function createBoundFunction () {
    let myBoundFunction = undefined;
    const myFunction = (...args) => myBoundFunction(...args);
    return (func) => {
        myBoundFunction = func;
        return myFunction;
    };
}
